const SidebarListItemStyles = {
  root: {
    paddingTop: 1,
    paddingBottom: 0,
    paddingX: 0,
  },
};

export default SidebarListItemStyles;
